export { default } from './NavItem.container';


// WEBPACK FOOTER //
// ./src/components/shared/NavItem/index.ts